import * as React from "react";
import "./CaregiverPhoneValidationCodeEntryScreen.css";
import { isLoading, Loading } from "../Loading";
import { Intent, Spinner } from "@blueprintjs/core";
import { formatPhone } from "../phone_number";

interface CaregiverPhoneValidationCodeEntryScreenProps {
    showInternetError: string | null | Loading;
    onRequestCodeClick: (code: string) => void;
    onReceiveNewCodeClick: () => void;
    phoneNumber: string;
}

interface CaregiverPhoneValidationCodeEntryScreenState {
    code: string;
}

export class CaregiverPhoneValidationCodeEntryScreen extends React.Component<CaregiverPhoneValidationCodeEntryScreenProps, CaregiverPhoneValidationCodeEntryScreenState> {
    constructor(props: CaregiverPhoneValidationCodeEntryScreenProps) {
        super(props);
        this.state = {
            code: ""
        };
    }

    handleRequestCodeClick = () => {
        this.props.onRequestCodeClick(this.state.code);
    }

    handleChange = (newVal: string) => {
        this.setState({ code: newVal });
    }

    getDisplayPhoneNumber() {
        return formatPhone(this.props.phoneNumber);
    }

    render() {
        return (
            <div className={"CaregiverLandingPage__root"}>
                <h4 className={"text-secondary mb-0"}>We sent a code to: <span className="CaregiverPhoneValidationCodeEntryScreen__phoneSms">{this.getDisplayPhoneNumber()}</span></h4>
                <div className="control-group">
                    <label className="CaregiverPhoneValidationCodeEntryScreen__label">Sms code</label>
                    <input
                        required={true}
                        className={"form-control"}
                        onChange={(e) => this.handleChange(e.target.value)}
                        placeholder="Sms code"
                        value={this.state.code}
                        minLength={5}
                        maxLength={5}
                        type={"tel"}
                    />
                </div>
                {isLoading(this.props.showInternetError) ?
                    <Spinner intent={Intent.PRIMARY}/>
                    :
                    <div className={"CaregiverPhoneValidationCodeEntryScreen__buttonContainer"}>
                        <button className="btn btn-primary btn-xl" onClick={this.handleRequestCodeClick}>
                            Next!
                        </button>

                        <button
                            className="CaregiverPhoneValidationCodeEntryScreen__submit btn btn-link"
                            onClick={() => this.props.onReceiveNewCodeClick()}
                        >
                            Didn't receive a text?
                        </button>
                    </div>

                }
                <div className={"help-block text-danger"}>
                    {isLoading(this.props.showInternetError) ? null : this.props.showInternetError}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CaregiverPhoneValidationCodeEntryScreen.tsx